import $http from '@/services/HttpService';

const route = '/explore';

export default {
  getAirports() {
    return $http.get(route);
  },

  getAirport(code) {
    return $http.get(`${route}/${code}`);
  },

  getAirportStores(code) {
    return $http.get(`${route}/${code}/stores`);
  },

  getAirportStore(airportCode, storeId) {
    return $http.get(`${route}/${airportCode}/stores/${storeId}`);
  },
};



// WEBPACK FOOTER //
// ./src/services/ExploreService.js